import React from 'react'
import Button from './button'
import CustomModal from './custom-Modal'
import * as DialogPrimitive from '@radix-ui/react-dialog'

interface ModalProps {
    trigger: JSX.Element
    title: string
    description: string
    buttonText: string
    open?: boolean
    backFnc?: () => void
}

const ErrorDialog = React.memo<ModalProps>(({ trigger, buttonText, description, title, open }) => {
    return (
        <CustomModal
            trigger={trigger}
            title={title + '' + '😔'}
            forceOpen={open}
            description={description}
            actions={
                <div className="px-4 w-full flex py-3">
                    <DialogPrimitive.Close className="w-full">
                        <Button className="w-full uppercase">{buttonText}</Button>
                    </DialogPrimitive.Close>
                </div>
            }
        />
    )
})

export default ErrorDialog
